class GlobalJoinTeam{
    constructor() {
        this.fetchInvites();
    }
    fetchInvites(){
        const thisClass = this;
        $.ajax({
            url: '?do=fetchInvites',
            type: 'GET',
            dataType: '',
            data: {}
        }).done(function(data) {
            for(let i = 0; i < data['manager'].length; i++){
                thisClass.showManagerInvite(data['manager'][i]);
            }
            for(let i = 0; i < data['team-member'].length; i++){
                thisClass.showTeamMemberInvite(data['team-member'][i]);
            }
        });
    }

    showManagerInvite(inviteArr){
        Swal.fire({
            html: `<span class="text-center text-primary">`+inviteArr['admin_name']+` has invited you to manage their GoodAccess team called <b>"`+inviteArr['team_name']+`"</b>.</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: "Accept",
            cancelButtonText: "Decline",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                return this.acceptInvitation(inviteArr['id'],'manager');
            },
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    html: `<span class="text-center text-primary">Invitation has been accepted.<br/> Now you are part of team <b>"`+inviteArr['team_name']+`"</b>!</span>`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Ok, got it!",
                    customClass: {
                        confirmButton: "btn btn-primary"
                    }
                }).then((result) => {
                    window.location.href = "/?organizationID="+inviteArr['team_id']
                })
            } else {
                this.declineInvitation(inviteArr['id'],'manager');
            }
        });
    }

    showTeamMemberInvite(inviteArr){
        Swal.fire({
            html: `<span class="text-center text-primary">`+inviteArr['admin_name']+` has invited you to join their GoodAccess team called <b>"`+inviteArr['team_name']+`"</b>.</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: "Accept",
            cancelButtonText: "Decline",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                return this.acceptInvitation(inviteArr['id'],'team-member');
            },
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    html: `<span class="text-center text-primary">Invitation has been accepted.<br/> Now you are part of team <b>"`+inviteArr['team_name']+`"</b>!</span>`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Ok, got it!",
                    customClass: {
                        confirmButton: "btn btn-primary"
                    }
                }).then((result) => {
                    window.location.href = "/?organizationID="+inviteArr['team_id']
                });
            } else {
                this.declineInvitation(inviteArr['id'],'team-member');
            }
        });
    }
    declineInvitation(invitationId,type,teamName){
        return fetch('?do=declineInvitation&invitationId='+invitationId+'&type='+type)
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText)
                }
                return response.json();
            }).catch(error => {
                Swal.showValidationMessage(`Request failed: ${error}`)
            });
    }

    acceptInvitation(invitationId, type){
        return fetch('?do=acceptInvitation&invitationId='+invitationId+'&type='+type)
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText)
                }
                return response.json();
            }).catch(error => {
                Swal.showValidationMessage(`Request failed: ${error}`)
            });
    }
}

window.GlobalJoinTeam = GlobalJoinTeam;